__turbopack_context__.v({
  "reactions": "_6t5Via_reactions",
});
